module.exports = __webpack_public_path__ + "static/media/trash-alt.789a5639.svg";